import * as React from "react"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogTitle from "@mui/material/DialogTitle"

interface IDiscardDialogProps {
  open: boolean
  setOpen: (value: ((prevState: boolean) => boolean) | boolean) => void
  onAcceptClick: () => void
}

export default function DiscardDialog({ open, setOpen, onAcceptClick }: IDiscardDialogProps) {
  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{"Discard changes?"}</DialogTitle>
      <DialogContent sx={{ minWidth: 400 }}>
        <DialogContentText id="alert-dialog-description">
          You will lose all the changes.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant={"contained"}>
          Keep editing
        </Button>
        <Button onClick={onAcceptClick} color={"error"} autoFocus={true} variant={"contained"}>
          Discard changes
        </Button>
      </DialogActions>
    </Dialog>
  )
}
